/// <amd-module name="Test/Analytics/Common/Stores/AnnouncementStore" />
import { AnnouncementActions } from "Test/Analytics/Common/Actions/AnnouncementActions";
import { Store } from "VSS/Reflux/Store";

export interface IAnnouncementState {
    announcementText: string;
}

export class AnnouncementStore extends Store {
    private _state: IAnnouncementState;

    constructor(private _actions: AnnouncementActions) {
        super("");
        this._initialize();
    }

    public getState(): IAnnouncementState {
        return this._state;
    }

    public dispose(): void {
        this._actions.announceAction.removeListener(this._onUpdateAnnouncement);
    }

    private _initialize(): void {
        this._state = {} as IAnnouncementState;
        this._actions.announceAction.addListener(this._onUpdateAnnouncement);
    }

    private _onUpdateAnnouncement = (announcementText: string) => {
        this._state.announcementText = announcementText;
        this.emitChanged();
    };
}
